import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-values',
  template: '<router-outlet name="values"></router-outlet>',
  styles: []
})
export class ValuesComponent {
  @Input() source;
}
